import React from 'react';
import { UNCATEGORIZED_NAMES } from '../../../lib/helpers/products';

/**
 * Píldoras de categoría de Almacén: «Todas» · «Sin categoría» · una por
 * categoría. Un solo render para la vista de tarjetas y la de tabla: antes
 * cada una pintaba las suyas (la tabla en azul/naranja con sombra, las
 * tarjetas con radio 999 y un gris a mano) y al cambiar de vista cambiaba
 * la barra de filtros (auditoría de UI, UI-004).
 *
 * Mismo criterio que `Button`: la activa en el primario del sistema, el
 * resto outline, sin sombra.
 */
// Exportadas: la Sala del club social pinta sus categorías (una lista de
// nombres, con «Todo») con las mismas píldoras; el color sale de aquí.
export const PILDORA = 'px-5 py-2.5 rounded-sm border border-solid font-medium text-sm transition-colors';
export const PILDORA_ACTIVA = 'bg-[var(--primary)] text-[var(--primary-foreground)] border-[var(--primary)]';
export const PILDORA_INACTIVA = 'bg-[var(--card)] text-[var(--foreground)] border-[var(--border)] hover:bg-[var(--surface-subtle)]';

export default function PildorasCategoria({ categories = [], selected = 'All', onChange }) {
  const pildoras = [
    { key: 'All', label: 'Todas' },
    { key: 'Sin categoría', label: 'Sin categoría' },
    ...(Array.isArray(categories) ? categories : [])
      .filter((cat) => !UNCATEGORIZED_NAMES.includes(cat.name))
      .map((cat) => ({ key: cat.name, label: cat.name, id: cat.id })),
  ];
  return (
    <div className="wa-almacen-filter-row flex flex-wrap gap-3 items-center">
      {pildoras.map((pill) => (
        <button
          key={pill.id ?? pill.key}
          type="button"
          aria-pressed={selected === pill.key}
          onClick={() => onChange?.(pill.key)}
          className={`${PILDORA} ${selected === pill.key ? PILDORA_ACTIVA : PILDORA_INACTIVA}`}
        >
          {pill.label}
        </button>
      ))}
    </div>
  );
}
